
















import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import ContentSetDetails from "@/components/contentset/ContentSetDetails.vue";
import ContentSetDevices from "@/components/contentset/ContentSetDevices.vue";
import ContentSetEnquiry from "@/components/contentset/ContentSetEnquiry.vue";
import ContentSetProcess from "@/components/contentset/ContentSetProcess.vue";
import ContentSetProductCategory from "@/components/contentset/ContentSetProductCategory.vue";
import ContentSetManager from "@/components/contentset/ContentSetManager.vue";

import { IContentSet } from "../../models/interfaces/content/content-set.model.interface";
import { ContentSetModel } from "../../models/content/content-set.model";

const ContestSetModule = namespace("contentSetModule");

@Component({
  components: {
    ContentSetDetails,
    ContentSetDevices,
    ContentSetEnquiry,
    ContentSetProcess,
    ContentSetProductCategory,
    ContentSetManager
  }
})
export default class ContentSet extends Vue {
  @ContestSetModule.Action public retrieveContentSet;
  @ContestSetModule.Getter public contentSet;

  get getContentSetModel(): IContentSet {
    return this.contentSet;
  }

  @Prop() public id: number;

  @Provide() public contentSetModel: IContentSet = new ContentSetModel();

  private loading: boolean = true;

  @Watch("getContentSetModel", { deep: true })
  public onContentSetUpdate() {
    this.contentSetModel = this.contentSet;
  }

  public created() {
    this.getContentSet(this.id);
  }

  private getContentSet(id: number) {
    this.loading = true;
    this.retrieveContentSet(id).then((result) => {
      if (this.contentSet) {
        this.contentSetModel = this.contentSet;
        this.loading = false;
      }
    });
  }
}
